import {
  getSchema as getSchema1,
  getValidate as getValidate1,
  uiSchema as uiSchema1,
} from "./schema.requestRentioMoveServiceExit.1";
import { IExtraData } from "./schema.requestRentioMoveServiceExit.types";
import { getInitialValues } from "./schema.requestRentioMoveServiceExit.utils";

export const requestRentioMoveServiceExitSchema = (extraData: IExtraData) => {
  const initialValues = getInitialValues(extraData);

  return [
    {
      schema: getSchema1(initialValues, extraData),
      uiSchema: uiSchema1(extraData),
      validate: getValidate1(extraData),
    },
  ];
};
